import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'sage' | 'gold' | 'lilac' | 'ivory';
  className?: string;
}
export function Pill({
  children,
  tone = 'sage',
  className = ''
}: PillProps) {
  const tones: Record<string, string> = {
    sage: 'border-sage/35 bg-sage-light/70 text-sage-deep',
    gold: 'border-gold/45 bg-gold-soft/60 text-gold-ink',
    lilac: 'border-lilac/35 bg-lilac-light text-lilac-deep',
    ivory: 'border-ivory/25 bg-ivory/10 text-ivory'
  };
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} style={{
    fontSize: "8px"
  }} data-id="element-156" data-mp="1eygjgtapwbfz">
      {children}
    </span>;
}